import { render } from "./ThanksmailArea.vue?vue&type=template&id=c9d05794&scoped=true"
import script from "./ThanksmailArea.vue?vue&type=script&lang=js"
export * from "./ThanksmailArea.vue?vue&type=script&lang=js"

import "./ThanksmailArea.vue?vue&type=style&index=0&id=c9d05794&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d05794"]])

export default __exports__